import Helper, { DateFormat } from "@/services/Helper";

/**
 * TaskNoteModel
 */

class TaskNoteModel
{
    constructor(obj?: TaskNoteModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
        }
    }

    public Id?: string;
    
    public TaskId?: number;
    
    public RequestId?: number;
    
    public UserId?: number;
    
    public ClientId?: number;
    
    private _DateTaken?: string | null;

    public get DateTaken (): string | null
    {
        return Helper.dateToInput(this.DateTakenAsDate, DateFormat.DateTime) || null;
    }

    public set DateTaken (val: string | null)
    {
        this._DateTaken = val || null;
    }

    public get DateTakenAsDate (): Date | null
    {
        if (this._DateTaken)
        {
            return Helper.dateFromString(this._DateTaken)
        }

        return null;
    }

    public Note?: string; 

    public Options?: string;

    private _Modified?: string | null;

    public get Modified (): string | null
    {
        return Helper.dateToInput(this.ModifiedAsDate, DateFormat.DateTime) || null;
    }

    public set Modified (val:string | null)
    {
        this._Modified = val || null;
    }

    public get ModifiedAsDate (): Date | null
    {
        if (this._Modified)
        {
            return Helper.dateFromString(this.Modified);
        }

        return null;
    }

    public _Created?: string | null;
    
    public get Created(): string | null
    {
        return Helper.dateToInput(this.CreatedAsDate, DateFormat.DateTime);
    }

    public set Created (val: string | null)
    {
        this._Created = val || null;
    }

    public get CreatedAsDate (): Date | null
    {
        if (this._Created)
        {
            return Helper.dateFromString(this._Created);
        }

        return null;
    }
}

class NoteModel extends TaskNoteModel
{
    // ... alias
}

class TaskNoteModelFilter 
{
    public IncludeRequest?: boolean = false;
    
    public IncludeContact?: boolean = false;

    public Id?: Array<string> = [];
    
    public TaskId?: Array<number> = [];
    
    public RequestId?: Array<number> = [];
    
    public UserId?: Array<number> = [];
    
    public ClientId?: Array<number> = [];
    
    public StartDate?: Date = new Date();
    
    public EndDate?: Date = new Date();
    
    public Page?: number = 0;
    
    public Size?: number = 25;
}

class NoteModelFilter extends TaskNoteModelFilter 
{
    // ... alias
}


export { TaskNoteModel, NoteModel, TaskNoteModelFilter, NoteModelFilter  };